module.exports = __webpack_public_path__ + "img/sun.0aa85baf.svg";